import { render, staticRenderFns } from "./zbhd.vue?vue&type=template&id=413b0098&scoped=true&"
import script from "./zbhd.vue?vue&type=script&lang=js&"
export * from "./zbhd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b0098",
  null
  
)

export default component.exports